import { getAnalytics, logEvent } from 'firebase/analytics'
import { initFirebase } from './firebase'
import { logger } from '@/utils/logger'

const CONSENT_KEY = 'analytics_consent'

export function hasAnalyticsConsent(): boolean {
  return localStorage.getItem(CONSENT_KEY) === 'granted'
}

export function setAnalyticsConsent(granted: boolean) {
  localStorage.setItem(CONSENT_KEY, granted ? 'granted' : 'denied')
}

export function track(eventName: string, params?: Record<string, any>) {
  try {
    if (!hasAnalyticsConsent()) return
    const { app } = initFirebase()
    const analytics = getAnalytics(app)
    logEvent(analytics, eventName, params)
    logger.debug('track', eventName, params)
  } catch (error) {
    logger.error('[track error]', error)
    // noop in unsupported environments
  }
}


